import { render } from "./FENotasCreditosView.vue?vue&type=template&id=61917d9a&scoped=true"
import script from "./FENotasCreditosView.vue?vue&type=script&lang=js"
export * from "./FENotasCreditosView.vue?vue&type=script&lang=js"

import "./FENotasCreditosView.vue?vue&type=style&index=0&id=61917d9a&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61917d9a"]])

export default __exports__